export function tenantLabel(tenant, key, fallback) {
  const label = tenant?.settings?.labels?.[key];
  return label && label.trim() ? label.trim() : fallback;
}

export function wipLabel(tenant) {
  return tenantLabel(tenant, "wip", "WIP");
}
